import { CopyButton } from '@teach/ui'
import { useUiLang } from '@/i18n'
import { type PromptExample } from '../guideContent'
import { guideFor } from '../guideMessages'

const PromptCard = ({ topic, text }: PromptExample) => (
  <li className="flex flex-col justify-between gap-4 rounded-2xl bg-foreground/5 p-4">
    <div className="space-y-2">
      <span className="inline-block rounded-md bg-brand/15 px-2 py-0.5 text-xs font-medium text-brand">
        {topic}
      </span>
      <p className="text-sm leading-relaxed text-foreground">{text}</p>
    </div>
    <CopyButton value={text} variant="ghost" className="self-start" />
  </li>
)

/** Три примера запросов на разные темы: карточки с темой и копированием. Колонка
 *  не уже 260px — в три узкие колонки на планшете текст шёл столбиком по 2–3 слова. */
export const PromptCards = () => (
  <ul className="grid gap-3 [grid-template-columns:repeat(auto-fit,minmax(min(100%,260px),1fr))]">
    {guideFor(useUiLang()).prompts.map((prompt) => (
      <PromptCard key={prompt.topic} {...prompt} />
    ))}
  </ul>
)
